import {ENTRY_FORMATTING_PORT} from '../../../../../shared/domain/tokens/entry-formatting.token';
import {inject, Injectable} from '@angular/core';
import {DEVICE} from "../../../../../shared/domain/tokens/device.token";
import {IApiBookingEntry} from "../../../booking/infrastructure/interfaces/booking-api.interface";
import {Account} from "../../domain/model/account.model";

export interface ISaveAccountEntriesRequest {
  deviceId: string;
  bookingId: string;
  entries: IApiBookingEntry[];
}

@Injectable({providedIn: 'root'})
export class SaveAccountEntriesRequestBuilder {
  private readonly entryFormatter = inject(ENTRY_FORMATTING_PORT);
  private readonly deviceService = inject(DEVICE);

  build(account: Account): ISaveAccountEntriesRequest | null {
    const deviceId = this.deviceService.getDeviceInfo()?.id;

    if (!account || !deviceId) {
      return null;
    }

    return {
      deviceId,
      bookingId: account.bookingId,
      entries: this.entryFormatter.toReleaseDtoList(account.entries) as IApiBookingEntry[],
    };
  }
}
